export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9728.3ed432b1.jpg";